<template>
  <q-layout view="hHh lpR fFf" class="main-layout">
    <Header class="headerSize" />

    <q-page-container>
      <div id="info-text">
        This demo project showcases Medical Connections's DICOM WebViewer that
        can be used together with DicomObjects's Restful Dicom Web Server
        or any other Dicom Web Server that adheres to the DICOM standard. <br />
        Should you wish to purchase a copy of the Web Viewer source, please contact us <a href="mailto:sales@medicalconnections.co.uk" style="color: #C2C2C2;">sales@medicalconnections.co.uk</a>
      </div>
      <StudiesTable class="tableSize vertical-middle" />
    </q-page-container>

    <!--Footer class="footerSize" /-->
  </q-layout>
</template>

<script>
import StudiesTable from "../components/StudiesTable.vue";
import Header from "../components/Header.vue";

export default {
  name: "Studies",
  components: {
    StudiesTable,
    Header,
  },
};
</script>

<style>
/* Should add up to 100 at most */
.headerSize {
  height: 12vh;
}

.footerSize {
  height: 8vh;
}
#info-text {
  margin-top: 35px;
  color: #adafb1;
}

.main-layout {
  font-family: Roboto;
}
</style>
